/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import { UserAuth } from "../context/authContext";
import { clsx } from "clsx";
import toast from "react-hot-toast";
import { FaRegClipboard, FaHome, FaChartLine, FaNetworkWired, FaExchangeAlt } from "react-icons/fa";
import { FiMenu, FiGrid, FiLayers, FiList } from "react-icons/fi";
import {
  addDoc,
  collection,
  serverTimestamp,
  where,
  doc,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import { SHA256 } from "crypto-js";
import { signTransaction } from "./CreateRoom";
import firebase from "firebase/compat/app";
import Arrow from "../components/assets/leadingArrow.png";
import dayjs from "dayjs";
import BlockTransactionsModal from "./BlockTransactionsModal";

function Content({ user, userData }) {
  const [roomId, setRoomId] = useState(localStorage.getItem("roomId") || "");
  const [datax, setDatax] = useState("");
  const [roomType, setRoomType] = useState("");
  const [role, setRole] = useState(() => localStorage.getItem("role") || "");
  const [blocks, setBlocks] = useState([]);
  const [createdBy, setCreatedBy] = useState([]);
  const [selectedBlockForModal, setSelectedBlockForModal] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openBlockModal = (block) => {
    setSelectedBlockForModal(block);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (!roomId) return;
    const unsubscribe = db
      .collection("rooms")
      .doc(roomId)
      .onSnapshot(
        (roomSnapshot) => {
          if (roomSnapshot.exists) {
            const data = roomSnapshot.data();
            setDatax(data);
            setRoomType(data.roomType);
            setCreatedBy(data.createdBy || []);
          } else {
            setRoomType("");
            toast.error("Room ID is invalid or does not exist.");
          }
        },
        (error) => console.error("Error fetching room:", error)
      );
    return () => unsubscribe();
  }, [roomId]);

  const handleLeaveRoom = async () => {
    try {
      await db
        .collection("rooms")
        .doc(roomId)
        .update({
          [`${role}s`]: firebase.firestore.FieldValue.arrayRemove(userData.publicKey),
        });
      setRoomId("");
      localStorage.removeItem("roomId");
      localStorage.removeItem("role");
      toast.success("Left room successfully.");
      window.location.href = "/dashboard";
    } catch (error) {
      toast.error("Failed to leave room.");
    }
  };

  const handleEndRoom = async () => {
    if (roomId && user.email) {
      try {
        const roomDocRef = db.collection("rooms").doc(roomId);
        const subcollectionNames = ["blocks", "transactions"];
        await Promise.all(
          subcollectionNames.map(async (subcollectionName) => {
            const subcollectionRef = roomDocRef.collection(subcollectionName);
            const docs = await subcollectionRef.get();
            docs.forEach(async (doc) => await doc.ref.delete());
          })
        );
        await roomDocRef.delete();
        toast.success("Room ended successfully.");
        window.location.href = "/dashboard";
        setRoomId("");
        localStorage.removeItem("roomId");
      } catch (error) {
        toast.error("Failed to end room.");
      }
    }
  };

  const copyToClipboard = (data) => {
    navigator.clipboard.writeText(data).then(
      () => toast.success("Copied Successfully"),
      () => toast.error("Failed to copy")
    );
  };

  const fetchBlocks = async () => {
    if (!roomId) return;
    try {
      const roomRef = doc(db, "rooms", roomId);
      const blocksRes = await getDocs(
        query(collection(roomRef, "blocks"), orderBy("timestamp", "asc"))
      );
      setBlocks(blocksRes.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, [roomId]);

  return (
    <div className="space-y-6">
      {/* User Info Card */}
      <div className="glass-card p-6 md:p-8 rounded-2xl relative overflow-hidden">
        <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-4">
            <div>
              <h2 className="text-2xl font-bold text-white">Hello, {user?.email}</h2>
              <p className="text-text-muted mt-1">
                Wallet Balance:{" "}
                <span className="text-primary font-bold">
                  {(userData?.balance || 0).toFixed(2)} COINS
                </span>
              </p>
            </div>

            <div className="space-y-3">
              <div className="bg-black/30 p-3 rounded-xl border border-white/5">
                <p className="text-xs text-text-muted mb-1 uppercase tracking-wide">Public Key</p>
                <div className="flex items-center gap-2">
                  <code className="text-sm font-mono text-white truncate flex-1">
                    {userData?.publicKey || "No Data"}
                  </code>
                  <button
                    onClick={() => copyToClipboard(userData?.publicKey)}
                    className="text-text-muted hover:text-white p-1"
                  >
                    <FaRegClipboard />
                  </button>
                </div>
              </div>

              <div className="bg-black/30 p-3 rounded-xl border border-white/5">
                <p className="text-xs text-text-muted mb-1 uppercase tracking-wide">Private Key</p>
                <div className="flex items-center gap-2">
                  <code className="text-sm font-mono text-white truncate flex-1">
                    {userData?.privateKey
                      ? userData.privateKey.substring(0, 15) + "..."
                      : "No Data"}
                  </code>
                  <button
                    onClick={() => copyToClipboard(userData?.privateKey)}
                    className="text-text-muted hover:text-white p-1"
                  >
                    <FaRegClipboard />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col justify-between">
            <div className="bg-white/5 p-4 rounded-xl border border-white/10 text-center">
              <p className="text-text-muted text-sm mb-2">Current Room ID</p>
              <div className="flex items-center justify-center gap-2">
                <code className="text-lg font-bold text-white">{roomId || "Not in Room"}</code>
                <button
                  onClick={() => copyToClipboard(roomId)}
                  className="text-primary hover:text-secondary"
                >
                  <FaRegClipboard />
                </button>
              </div>
            </div>

            <div className="mt-4 flex justify-end">
              {createdBy === user.email ? (
                <button
                  onClick={handleEndRoom}
                  className="px-6 py-2 bg-red-500/20 text-red-400 border border-red-500/50 rounded-xl hover:bg-red-500/30 transition-colors"
                >
                  End Room
                </button>
              ) : (
                <button
                  onClick={handleLeaveRoom}
                  className="px-6 py-2 bg-red-500/20 text-red-400 border border-red-500/50 rounded-xl hover:bg-red-500/30 transition-colors"
                >
                  Leave Room
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Lists Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="glass-card p-6 h-80 overflow-hidden flex flex-col">
          <ListOfParticipants roomId={roomId} />
        </div>
        <div className="glass-card p-6 h-80 overflow-hidden flex flex-col">
          {datax.roomType === "ASTRAPOS" ? (
            <ListOfStakers roomId={roomId} />
          ) : (
            <ListOfMiners roomId={roomId} />
          )}
        </div>
      </div>

      {/* Transaction & Blocks */}
      <div className="flex flex-col gap-6">
        <div className="glass-card p-6">
          <CreateTransactionComponent user={user} userData={userData} roomId={roomId} />
        </div>
        <div className="glass-card p-6">
          <BlockComponent user={user} blocks={blocks} onBlockClick={openBlockModal} />
        </div>
      </div>

      <BlockTransactionsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        block={selectedBlockForModal}
        team="blue"
      />
    </div>
  );
}

function BlockComponent({ user, blocks, onBlockClick }) {
  return (
    <div className="flex flex-col min-h-[500px] w-full">
      <div className="flex items-center gap-3 mb-6 p-2">
        <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center text-primary">
          <FiLayers size={22} />
        </div>
        <h1 className="text-xl font-bold text-white">Blockchain Explorer</h1>
      </div>

      <div className="flex flex-row w-full flex-1 p-2 overflow-x-auto gap-6 pb-6 custom-scrollbar items-start">
        {blocks && blocks.length > 0 ? (
          blocks.map((b, index) => (
            <div key={b.id || index} className="flex-shrink-0 flex items-center gap-4">
              {/* Block Card */}
              <div
                className="flex flex-col w-80 h-full rounded-2xl bg-white/5 border border-white/10 hover:border-primary/50 transition-all duration-300 relative overflow-hidden group cursor-pointer hover:bg-white/10"
                onClick={() => onBlockClick(b)}
              >
                <div className="absolute top-0 w-full h-1 bg-gradient-to-r from-primary to-secondary" />

                <div className="p-4 border-b border-white/5 bg-black/20 flex justify-between items-center">
                  <h1 className="font-bold text-white">Block #{index + 1}</h1>
                  <span className="text-xs px-2 py-1 rounded bg-white/10 text-text-muted">
                    Difficulty: 2
                  </span>
                </div>

                <div className="p-4 flex-1 space-y-4 overflow-y-auto max-h-[400px] custom-scrollbar">
                  <div className="space-y-1">
                    <label className="text-xs text-text-muted uppercase font-semibold">
                      Block Hash
                    </label>
                    <div className="text-xs font-mono text-primary break-all bg-black/30 p-2 rounded border border-white/5">
                      {b.hash}
                    </div>
                  </div>

                  <div className="space-y-1">
                    <label className="text-xs text-text-muted uppercase font-semibold">
                      Previous Hash
                    </label>
                    <div className="text-xs font-mono text-secondary break-all bg-black/30 p-2 rounded border border-white/5">
                      {b.previousBlockHash || "Genesis"}
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-2">
                    <div className="bg-white/5 p-2 rounded">
                      <label className="text-[10px] text-text-muted uppercase">Creation Date</label>
                      <div className="text-xs text-white">
                        {b.timestamp
                          ? typeof b.timestamp === "number"
                            ? dayjs.unix(b.timestamp).format("MMM DD, YYYY HH:mm:ss")
                            : dayjs(b.timestamp).format("MMM DD, YYYY HH:mm:ss")
                          : "N/A"}
                      </div>
                    </div>
                    <div className="bg-white/5 p-2 rounded">
                      <label className="text-[10px] text-text-muted uppercase">Nonce</label>
                      <div className="text-xs text-white">{b.nonce ?? 0}</div>
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label className="text-xs text-text-muted uppercase font-semibold flex justify-between">
                      <span>Transactions</span>
                      <span className="text-white bg-primary/20 px-1.5 rounded text-[10px]">
                        {(b.transactions && b.transactions.length) || 0}
                      </span>
                    </label>
                    <ul className="space-y-2 max-h-32 overflow-y-auto custom-scrollbar">
                      {b.transactions &&
                        b.transactions.map((t, i) => (
                          <li
                            key={i}
                            className="flex gap-2 items-center bg-black/20 p-1.5 rounded border border-white/5"
                          >
                            <span className="text-xs text-text-muted w-4">{i + 1}.</span>
                            <span className="text-xs font-mono text-white truncate flex-1">
                              {t.hash}
                            </span>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Arrow Connector (if not last) */}
              {index < blocks.length - 1 && (
                <div className="text-text-muted/30">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="w-full h-full flex items-center justify-center text-text-muted gap-2">
            <p>No blocks mined yet. Start a transaction!</p>
          </div>
        )}
      </div>
    </div>
  );
}

function CreateTransactionComponent({ user, userData }) {
  const [roomId, setRoomId] = useState(localStorage.getItem("roomId") || "");
  const [senderprivateKey, setsenderprivateKey] = useState("");
  const [transactionReceiverPublicKey, setTransactionReceiverPublicKey] = useState("");
  const [transactionAmount, setTransactionAmount] = useState("");
  const [isTransactionSigned, setIsTransactionSigned] = useState(false);
  let [signature, setSignature] = useState(null);
  const [transactionHash, setTransactionHash] = useState(null);

  const handleGenerateSignature = async (receiverPublicKey, amount) => {
    if (!receiverPublicKey || amount <= 0) {
      toast.error("Invalid receiver public key or amount");
      return;
    }

    try {
      await generateSignature(receiverPublicKey, amount);
    } catch (error) {
      console.error("Error generating signature:", error.message);
      toast.error("Error generating signature");
    }
  };

  const handleCreateTransaction = async (receiverPublicKey, amount) => {
    if (!isTransactionSigned) {
      toast.error("Please sign the transaction first");
      return;
    }

    if (!receiverPublicKey || amount <= 0) {
      toast.error("Invalid receiver public key or amount");
      return;
    }

    try {
      await createTransaction(receiverPublicKey, amount);
    } catch (error) {
      toast.error("Error creating transaction");
    }
  };

  const generateSignature = async (receiverPublicKey, amount) => {
    // Generate transaction data
    const transactionData = {
      sender: userData.publicKey,
      senderEmail: user.email,
      receiver: receiverPublicKey,
      nonce: Math.floor(Math.random() * (10 - 1)) + 1,
      amount: Number(amount),
      status: "Verify", // Initial status of the transaction
    };

    if (!senderprivateKey) {
      toast.error("Private key is required to sign the transaction");
      return;
    }
    let data = await signTransaction(transactionData, senderprivateKey);
    setSignature(data);
    if (!data) {
      toast.error("Failed to generate signature");
      return;
    }
    toast.success("Signature generated successfully using RSA, now create transaction");
    setIsTransactionSigned(true);
  };

  const createTransaction = async (receiverPublicKey, amount) => {
    if (!signature) {
      toast.error("Signature is missing");
      return;
    }

    // Add signature to transaction data
    const transactionData = {
      sender: userData.publicKey,
      senderEmail: user.email,
      receiver: receiverPublicKey,
      nonce: Math.floor(Math.random() * (10 - 1)) + 1,
      amount: Number(amount),
      status: "Verify", // Initial status of the transaction
      signature: signature,
    };

    // Create transaction in Firestore
    try {
      const hash = SHA256(JSON.stringify(transactionData)).toString();
      await addDoc(collection(db, "rooms", roomId, "transactions"), {
        ...transactionData,
        hash,
        timestamp: serverTimestamp(),
      });
      toast.success(`Transaction sent successfully with Hash : ${hash}`);
      setsenderprivateKey("");
      setTransactionReceiverPublicKey("");
      setTransactionAmount("");
      setIsTransactionSigned(false);
      setTransactionHash(hash);
    } catch (error) {
      console.error("Error making transaction", error.message);
      toast.error("Error making transaction", error.message);
    }
  };
  return (
    <div className="h-full flex flex-col justify-center">
      <div className="flex items-center gap-3 mb-6 border-b border-white/5 pb-4">
        <div className="w-10 h-10 rounded-full bg-secondary/20 flex items-center justify-center text-secondary">
          <FaExchangeAlt size={22} />
        </div>
        <h1 className="text-xl font-bold text-white">Create Transaction</h1>
      </div>

      <div className="space-y-4 max-w-xl mx-auto w-full">
        <div>
          <label className="block text-sm font-medium text-text-muted mb-1">
            Receiver Public Key
          </label>
          <input
            type="text"
            className="w-full bg-surfaceHighlight border border-border rounded-xl px-4 py-3 text-white placeholder-text-muted focus:outline-none focus:border-secondary focus:ring-1 focus:ring-secondary transition-colors"
            placeholder="Enter receiver's key"
            value={transactionReceiverPublicKey}
            onChange={(e) => {
              setTransactionReceiverPublicKey(e.target.value);
              setIsTransactionSigned(false);
            }}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-text-muted mb-1">
            Sender Private Key
          </label>
          <input
            className="w-full bg-surfaceHighlight border border-border rounded-xl px-4 py-3 text-white placeholder-text-muted focus:outline-none focus:border-secondary focus:ring-1 focus:ring-secondary transition-colors"
            type="password"
            placeholder="Enter your private key"
            value={senderprivateKey}
            onChange={(e) => {
              setsenderprivateKey(e.target.value);
              setIsTransactionSigned(false);
            }}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-text-muted mb-1">Amount</label>
          <input
            className="w-full bg-surfaceHighlight border border-border rounded-xl px-4 py-3 text-white placeholder-text-muted focus:outline-none focus:border-secondary focus:ring-1 focus:ring-secondary transition-colors"
            type="number"
            placeholder="0.00"
            value={transactionAmount}
            onChange={(e) => {
              setTransactionAmount(e.target.value);
              setIsTransactionSigned(false);
            }}
          />
        </div>

        <div className="grid grid-cols-2 gap-4 mt-6">
          <button
            className={`flex items-center justify-center py-3 rounded-xl font-bold transition-all ${isTransactionSigned ? "bg-green-500/20 text-green-400 border border-green-500/50 cursor-not-allowed" : "bg-primary hover:bg-primary/80 text-white shadow-lg shadow-primary/20"}`}
            onClick={() => handleGenerateSignature(transactionReceiverPublicKey, transactionAmount)}
            disabled={isTransactionSigned}
          >
            {isTransactionSigned ? "Signed ✓" : "Sign Transaction"}
          </button>

          <button
            className={`flex items-center justify-center py-3 rounded-xl font-bold transition-all ${!isTransactionSigned ? "bg-white/5 text-text-muted cursor-not-allowed" : "bg-gradient-to-r from-primary to-secondary text-white hover:scale-[1.02] shadow-[0_0_20px_rgba(236,72,153,0.3)]"}`}
            onClick={() => handleCreateTransaction(transactionReceiverPublicKey, transactionAmount)}
            disabled={!isTransactionSigned}
          >
            Send Coins
          </button>
        </div>

        {transactionHash && (
          <div className="mt-6 p-4 bg-green-500/10 border border-green-500/20 rounded-xl">
            <p className="text-sm text-green-400 font-semibold mb-1">Transaction Successful!</p>
            <p className="text-xs text-text-muted break-all font-mono">{transactionHash}</p>
          </div>
        )}
      </div>
    </div>
  );
}

function ListOfMiners({ roomId }) {
  const [miners, setMiners] = useState([]);

  useEffect(() => {
    if (!roomId) return;

    const unsubscribe = db
      .collection("rooms")
      .doc(roomId)
      .onSnapshot(async (doc) => {
        if (doc.exists) {
          const roomData = doc.data();
          if (roomData.miners && roomData.miners.length > 0) {
            const users = await getDocs(
              query(collection(db, "users"), where("publicKey", "in", roomData.miners))
            );
            setMiners(users.docs.map((v) => v.data()));
          } else {
            setMiners([]);
          }
        }
      });
    return () => unsubscribe();
  }, [roomId]);

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex items-center gap-2 mb-4 border-b border-white/5 pb-2">
        <div className="w-8 h-8 rounded-full bg-secondary/20 flex items-center justify-center text-secondary">
          <FiLayers />
        </div>
        <h1 className="text-lg font-bold text-white">Miners</h1>
        <span className="ml-auto bg-white/10 text-xs px-2 py-1 rounded text-text-muted">
          {miners.length}
        </span>
      </div>

      <div className="overflow-y-auto pr-2 custom-scrollbar space-y-2 flex-1">
        {miners.length > 0 ? (
          miners.map((participant, index) => (
            <div
              key={index}
              className="bg-white/5 hover:bg-white/10 transition-colors p-3 rounded-xl border border-white/5 flex items-center justify-between group"
            >
              <div className="flex items-center gap-3 overflow-hidden">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-green-500 to-emerald-500 flex items-center justify-center text-xs font-bold text-white">
                  {participant.email?.charAt(0).toUpperCase()}
                </div>
                <div className="flex flex-col min-w-0">
                  <span className="text-sm font-medium text-white truncate">
                    {participant.email}
                  </span>
                  <span className="text-xs text-text-muted font-mono truncate w-32">
                    {participant.publicKey}
                  </span>
                </div>
              </div>
              <button
                onClick={() =>
                  navigator.clipboard
                    .writeText(participant.publicKey)
                    .then(() => toast.success("Copied!"))
                }
                className="text-text-muted hover:text-white opacity-0 group-hover:opacity-100 transition-opacity p-2"
              >
                <FaRegClipboard />
              </button>
            </div>
          ))
        ) : (
          <div className="text-center text-text-muted py-10">No miners active</div>
        )}
      </div>
    </div>
  );
}

function ListOfStakers({ roomId }) {
  const [stakingwallet, setStakingwallet] = useState(0);
  const [stakers, setStakers] = useState([]);

  useEffect(() => {
    if (!roomId) return;

    const unsubscribe = db
      .collection("rooms")
      .doc(roomId)
      .onSnapshot(async (doc) => {
        if (doc.exists) {
          const roomData = doc.data();

          // Logic for staking wallet calculation
          let max = 0;
          let publicKey;
          let mp = {};

          if (roomData.stakers && roomData.stakers.length > 0) {
            roomData.stakers.forEach((staker) => {
              if (staker.stake > max) {
                max = staker.stake;
                publicKey = staker.publicKey;
              }
              mp[staker.publicKey] = staker.stake;
            });
            setStakingwallet(max); // Simplified for display

            const users = await getDocs(
              query(
                collection(db, "users"),
                where(
                  "publicKey",
                  "in",
                  roomData.stakers.map((i) => i.publicKey)
                )
              )
            );

            setStakers(users.docs.map((v) => ({ ...v.data(), stake: mp[v.data().publicKey] })));
          } else {
            setStakers([]);
            setStakingwallet(0);
          }
        }
      });

    return () => unsubscribe();
  }, [roomId]);

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex items-center gap-2 mb-4 border-b border-white/5 pb-2">
        <div className="w-8 h-8 rounded-full bg-yellow-500/20 flex items-center justify-center text-yellow-500">
          <FaChartLine />
        </div>
        <div className="flex-1">
          <h1 className="text-lg font-bold text-white">Stakers</h1>
          <p className="text-[10px] text-text-muted uppercase">Updates Live</p>
        </div>
        <div className="text-right">
          <span className="block text-xs text-text-muted">Top Stake</span>
          <span className="font-bold text-yellow-500">{stakingwallet}</span>
        </div>
      </div>

      <div className="overflow-y-auto pr-2 custom-scrollbar space-y-2 flex-1">
        {stakers.length > 0 ? (
          stakers.map((participant, index) => (
            <div
              key={index}
              className="bg-white/5 hover:bg-white/10 transition-colors p-3 rounded-xl border border-white/5 flex items-center justify-between group"
            >
              <div className="flex items-center gap-3 overflow-hidden">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-yellow-500 to-orange-500 flex items-center justify-center text-xs font-bold text-white shadow-lg shadow-orange-500/20">
                  {participant.email?.charAt(0).toUpperCase()}
                </div>
                <div className="flex flex-col min-w-0">
                  <span className="text-sm font-medium text-white truncate">
                    {participant.email}
                  </span>
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-text-muted font-mono truncate w-20">
                      {participant.publicKey}
                    </span>
                    <span className="text-xs bg-yellow-500/20 text-yellow-500 px-1 rounded">
                      {participant.stake ?? 0}
                    </span>
                  </div>
                </div>
              </div>
              <button
                onClick={() =>
                  navigator.clipboard
                    .writeText(participant.publicKey)
                    .then(() => toast.success("Copied!"))
                }
                className="text-text-muted hover:text-white opacity-0 group-hover:opacity-100 transition-opacity p-2"
              >
                <FaRegClipboard />
              </button>
            </div>
          ))
        ) : (
          <div className="text-center text-text-muted py-10">No stakers active</div>
        )}
      </div>
    </div>
  );
}

function ListOfParticipants({ roomId }) {
  const [participants, setParticipants] = useState([]);

  useEffect(() => {
    if (!roomId) return;

    const unsubscribe = db
      .collection("rooms")
      .doc(roomId)
      .onSnapshot(async (doc) => {
        if (doc.exists) {
          const roomData = doc.data();
          if (roomData.participants && roomData.participants.length > 0) {
            const users = await getDocs(
              query(collection(db, "users"), where("publicKey", "in", roomData.participants))
            );
            setParticipants(users.docs.map((v) => v.data()));
          } else {
            setParticipants([]);
          }
        }
      });

    return () => unsubscribe();
  }, [roomId]);

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex items-center gap-2 mb-4 border-b border-white/5 pb-2">
        <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center text-primary">
          <FiList />
        </div>
        <h1 className="text-lg font-bold text-white">Participants</h1>
        <span className="ml-auto bg-white/10 text-xs px-2 py-1 rounded text-text-muted">
          {participants.length}
        </span>
      </div>

      <div className="overflow-y-auto pr-2 custom-scrollbar space-y-2 flex-1">
        {participants.length > 0 ? (
          participants.map((participant, index) => (
            <div
              key={index}
              className="bg-white/5 hover:bg-white/10 transition-colors p-3 rounded-xl border border-white/5 flex items-center justify-between group"
            >
              <div className="flex items-center gap-3 overflow-hidden">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-purple-500 to-indigo-500 flex items-center justify-center text-xs font-bold text-white">
                  {participant.email?.charAt(0).toUpperCase()}
                </div>
                <div className="flex flex-col min-w-0">
                  <span className="text-sm font-medium text-white truncate">
                    {participant.email}
                  </span>
                  <span className="text-xs text-text-muted font-mono truncate w-32">
                    {participant.publicKey}
                  </span>
                </div>
              </div>
              <button
                onClick={() =>
                  navigator.clipboard
                    .writeText(participant.publicKey)
                    .then(() => toast.success("Copied!"))
                }
                className="text-text-muted hover:text-white opacity-0 group-hover:opacity-100 transition-opacity p-2"
              >
                <FaRegClipboard />
              </button>
            </div>
          ))
        ) : (
          <div className="text-center text-text-muted py-10">No participants yet</div>
        )}
      </div>
    </div>
  );
}

export default function RoomDashBoard() {
  const { userData, user } = UserAuth();

  // Navigation is now handled by the global MainLayout sidebar

  return (
    <div className="max-w-[1600px] space-y-6">
      <Content user={user} userData={userData} />
    </div>
  );
}
